import React, { Component } from 'react';
// import { StaticQuery, graphql } from 'gatsby';
// import { withPrefix } from "gatsby";
import mapStyles from './map.module.sass';

// Before deployment, must add maps API restriction https://console.cloud.google.com/google/maps-apis/overview?consoleReturnUrl=https:%2F%2Fcloud.google.com%2Fmaps-platform%2F%3Fapis%3Dmaps%26project%3Dtruffle-pigs-1547647007881&consoleUI=CLOUD&project=truffle-pigs-1547647007881

  export default class Map extends Component {

    constructor (props) {
      super(props);
      this.onScriptLoad = this.onScriptLoad.bind(this);
    }

  componentDidMount() {
    if (!window.google) {
      const s = document.createElement('script');
      const ApiKey = 'AIzaSyBo08sG6JYHAGKFaT8ZSgLyUUTYWIfOOwI';
      s.type = 'text/javascript';
      s.async = true;
      s.defer = true;
      s.src = `https://maps.google.com/maps/api/js?key=${ApiKey}`;
      const x = document.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(s, x);
      // Below is important.
      // We cannot access google.maps until it's finished loading
      s.addEventListener ('load', () => {
        this.onScriptLoad();
      });
    } else {
      this.onScriptLoad();
    }
  }
  
  onScriptLoad() {

    const {id, options, onMapLoad} = this.props

    // this.map = new window.google.maps.Map(
    const map = new window.google.maps.Map (
      document.getElementById(id),
      options
    );

    onMapLoad(map);
  }

  render() {
    const { id, addClasses} = this.props
    return <div id={id} className={[mapStyles.map, addClasses].join(' ')} />;
  }
}